import { Component, Inject, OnInit } from '@angular/core';
import { AuthService } from '@service/auth.service';
import { Vessel } from 'icreate/common/models/vessel';
import { UserCompanyService } from '@service/user-company.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { VersionsHistoryService } from '@service/versions-history.service';
import { PublishedVersion } from 'icreate/common/models/versions-history';
import { VesselOwnershipStatus } from 'icreate/common/models/vessel-ownership-transfer';
import {
    vesselOwnershipTransferCommentLength,
    vesselOwnershipTransferValidator,
} from 'icreate/common/validators/vessel-ownership-transfer/vessel-ownership-transfer-validator';

@Component({
    selector: 'app-release-ownership-dialog',
    templateUrl: './release-ownership-dialog.component.html',
    styleUrls: ['./release-ownership-dialog.component.css'],
    standalone: false,
})
export class ReleaseOwnershipDialogComponent implements OnInit {
    readonly COMMENT_MAX_LENGTH = vesselOwnershipTransferCommentLength;

    readonly UNASSIGNED = OwnershipAssignmentTypes.UNASSIGNED;
    readonly ASSIGNED = OwnershipAssignmentTypes.ASSIGNED;

    approversList: { name: string; email: string; oid: string }[];
    selectedUser: { name: string; email: string; oid: string } = {
        name: null,
        email: null,
        oid: null,
    };

    versions: PublishedVersion[];
    currentProjectVersion: string;

    customerRequestCheckbox: boolean = false;
    misconfigurationCheckbox: boolean = false;
    internalRequestCheckbox: boolean = false;
    otherCheckbox: boolean = false;
    otherReason: string;
    comment: string;

    isLoading: boolean = false;
    selectedAssignment: OwnershipAssignmentTypes;
    currentUser: { name: string; oid: string; email: string };

    constructor(
        private authService: AuthService,
        private userCompanyService: UserCompanyService,

        @Inject(MAT_DIALOG_DATA)
        public data: {
            vessel: Vessel;
            shipyardiApi: string;
        },
        private dialogRef: MatDialogRef<ReleaseOwnershipDialogComponent>,
        private versionHistoryService: VersionsHistoryService
    ) {}

    async ngOnInit() {
        this.isLoading = true;
        this.currentProjectVersion = this.data.vessel.projectVersion;
        const shipyardId = this.data.shipyardiApi;
        const vesselId = this.data.vessel.iAPIVesselId;
        this.currentUser = this.authService.getCurrentUser();
        this.versions = await this.versionHistoryService.getVersionsList(shipyardId, vesselId);
        this.approversList = (await this.userCompanyService.getUsersCompany(this.currentUser.oid)).filter(
            approver => approver.oid !== this.data.vessel.ownerOid || !approver.name || !approver.oid || !approver.email
        );

        this.selectedAssignment = OwnershipAssignmentTypes.ASSIGNED;
        this.isLoading = false;
    }

    isButtonDisabled(): boolean {
        return (
            this.selectedAssignment === this.ASSIGNED &&
            (!this.selectedUser?.name || !this.selectedUser?.email || !this.selectedUser?.oid)
        );
    }

    async releaseOwnership() {
        if (this.isButtonDisabled() || !this.data.shipyardiApi || !this.data.vessel) {
            return;
        }

        if (this.selectedAssignment === this.ASSIGNED) {
            this.dialogRef.close({
                isAssigned: true,
                selectedOwner: this.selectedUser,
                comment: this.comment,
                status: VesselOwnershipStatus.Assigned,
            });
        } else {
            this.dialogRef.close({
                isAssigned: false,
                selectedOwner: null,
                comment: this.comment,
                status: VesselOwnershipStatus.Left,
            });
        }
    }

    clearForm() {
        this.dialogRef.close();
    }

    public get validatorFunction() {
        return vesselOwnershipTransferValidator;
    }
}

export enum OwnershipAssignmentTypes {
    UNASSIGNED = 'unassigned',
    ASSIGNED = 'assigned',
    UNDEFINED = 'undefined',
}
